// src/services/apiClient.js
const apiKey = process.env.REACT_APP_API_KEY;

export const apiClient = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      Authorization: `SRL ${apiKey}`,
      ...options.headers,
    },
  });
  const data = await response.text();
  const parser = new DOMParser();
  return parser.parseFromString(data, 'text/xml');
};
